
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.9 29.61c-5.14 0-8.76 2.74-8.79 6.65 0 2.9 2.58 4.51 4.55 5.48s2.71 1.62 2.7 2.5c0 1.35-1.62 2-3.12 2a10.42 10.42 0 01-4.89-1.05l-.68-.32-.67 4.45a15.75 15.75 0 005.8 1.07c5.46 0 9-2.7 9.05-6.88 0-2.3-1.37-4-4.37-5.47-1.81-.93-2.93-1.55-2.92-2.5s.94-1.73 3-1.73a9.09 9.09 0 013.89.77l.46.23.71-4.37a12.85 12.85 0 00-4.66-.85zM33.75 30L30.5 50.1h5.2L39 30h-5.2zm-7.62 0L21 43.7l-.54-2.79c-1.27-3.42-4-7-7.21-8.46L18 50.08h5.5L31.64 30h-5.5zm37.75 0a2.57 2.57 0 00-2.73 1.67L53.43 50.1h5.47s.89-2.48 1.1-3h6.66c.16.7.63 3 .63 3h4.83L67.9 30h-4zm.37 5.43l.35 1.74L65.81 43h-4.32c.43-1.16 2.07-5.63 2.07-5.63s.43-1.16.69-1.92z","fill":"#00589f"}}),_c('path',{attrs:{"d":"M16.32 30H7.94v.35C14.41 32 18.71 36.08 20.5 40.92l-1.82-9.26A2.18 2.18 0 0016.32 30","fill":"#f9a51a"}}),_c('path',{attrs:{"d":"M0 0h80v80H0z","fill":"none"}})])
          )
        }
      }
    